(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('citiesController', citiesController)
        .controller('newCityController', newCityController)
        .controller('editCityController', editCityController)
        .controller('deleteCityController', deleteCityController);

    citiesController.$inject = ['linkService', 'tabs', 'cities'];
    newCityController.$inject = ['linkService', 'tabs', 'countries', 'regionService', 'cityService'];
    editCityController.$inject = ['linkService', 'tabs', 'countries', 'city', 'regionService', 'cityService', '$stateParams'];
    deleteCityController.$inject = ['city', 'cityService', '$uibModalInstance', '$stateParams'];

    function citiesController(linkService, tabs, cities){
        var vm = this;
        vm.linkService = linkService;
        vm.pages = [];

        vm.tabs = tabs;
        vm.cities = (cities.data._embedded) ? cities.data._embedded.cities : [];
        vm.pages = cities.data.page;
    }

    function newCityController(linkService, tabs, countries, regionService, cityService){
        var vm = this;
        vm.tabs = tabs;
        vm.countries = countries;
        vm.regions = [];
        vm.disableSelects = false;
        vm.linkService = linkService;

        vm.saveCity = function(isValid, city){
            if(isValid){
                var saveForm = {
                    "regionId": parseInt(linkService.getLinkId(city.region._links.self.href)),
                    "name": city.name,
                    "active": false
                }
                cityService.saveCity(saveForm);
            }
        }

        vm.regionsCountry = function(country){
            if(country !== undefined){
                regionService.getRegionsByCountry(linkService.getLinkId(country._links.self.href))
                    .then(function(response){
                        vm.regions = response;
                    });
            }else{
                vm.regions = [];
            }
        }

    }

    function editCityController(linkService, tabs, countries, city, regionService, cityService, $stateParams){
        var vm = this;
        vm.tabs = tabs;
        vm.cityIdRegionId = $stateParams.id;
        vm.countries = countries;
        vm.city = {
            'country': city.data._embedded.country,
            'region': city.data._embedded.region,
            'name':  city.data.name
        }
        vm.old = angular.copy(vm.city);
        vm.buttonSave = true;
        vm.disableSelects = true;
        vm.linkService = linkService;

        vm.regionsCountry = function(country){
            if(country != undefined){
                regionService.getRegionsByCountry(linkService.getLinkId(country._links.self.href))
                    .then(function(response){
                        vm.regions = response;
                    });
            }else{
                vm.regions = [];
            }
        }

        vm.regionsCountry(city.data._embedded.country);

        vm.saveCity = function(isValid, city){
            if(isValid){
                var saveForm = {
                    "regionId": parseInt(linkService.getLinkId(city.region._links.self.href)),
                    "name": city.name,
                    "active": false
                }
                cityService.updateCity(vm.cityIdRegionId, saveForm);
            }
        }

        vm.change = function(){
            if(vm.city.name != undefined && vm.city.country!=undefined && vm.city.country.name==vm.old.country.name &&
                vm.city.region.name==vm.old.region.name &&
                vm.city.name.toUpperCase()==vm.old.name.toUpperCase()){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }
    }

    function deleteCityController(city, cityService, $uibModalInstance, $stateParams){
        var vm = this;
        vm.city = city.data;
        vm.cityIdRegionId = $stateParams.id;

        vm.deleteCity = function(){
            cityService.deleteCity(vm.cityIdRegionId)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
